import React from 'react';
// import { LoadData } from '@saltus/ui'; // Commented out - @saltus dependency
import {useNavigate} from 'react-router-dom';
import {Box, Container, Grid} from '@mui/material';
import {MeetingTabs} from './components/MeetingTabs';
import {NAVIGATION_ITEMS} from './components/Navigation';
import SectionCard from './components/SectionCard';
import {useGetInvitations, useGetInvitationStats} from './invitationQueries';
import {themeColors} from '../../theme/Theme';

import ErrorMessage from '../../components/ErrorMessage/ErrorMessage';
import Loading from '../../components/Loading/Loading';
import {InvitationReviewsInput} from '../../schema-types/globalTypes';
import {ANNUAL_REVIEWS_NEW} from '../../constants/Routes';

function AnnualReviewsDashboard() {
  const {error, loading, stats} = useGetInvitationStats();

  const {data: _todaysMeetingsData} = useGetInvitations({
    inviteStatus: InvitationReviewsInput.TODAYS_MEETINGS,
  });

  const navigate = useNavigate();

  const navigateTo = (path: string) => () => {
    navigate(`/${ANNUAL_REVIEWS_NEW}/${path}`);
  };

  // Simple loading/error handling since LoadData is commented out
  if (loading) return <Loading entityName="dashboard" />;
  if (error) return <ErrorMessage error={error} />;
  if (!stats) return <ErrorMessage error={{message: 'No data available'}} />;

  return (
    <Box sx={{backgroundColor: themeColors.pageBackgroundColor, minHeight: '100vh'}}>
      <Container maxWidth="xl" sx={{py: 3}}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12} lg={6}>
            <SectionCard
              title={NAVIGATION_ITEMS.INVITES.label}
              icon={NAVIGATION_ITEMS.INVITES.icon}
              mainValue={stats.numberOfUpcomingReviewsNeedingInvitations || 0}
              invitations={{
                overdue: stats.numberOfOverdueReviewsNeedingInvitations || 0,
                upcoming: stats.numberOfUpcomingReviewsNeedingInvitations || 0,
              }}
              mainLabel="Upcoming"
              subLabel="Next 30 Days"
              buttonText={`Go to ${NAVIGATION_ITEMS.INVITES.label}`}
              buttonAction={navigateTo('invite')}
            />
          </Grid>
          <Grid item xs={12} md={12} lg={6}>
            <SectionCard
              title={NAVIGATION_ITEMS.INVITED.label}
              icon={NAVIGATION_ITEMS.INVITED.icon}
              mainValue={stats.numberOfOutstandingInvitations || 0}
              // chase={{
              //   first: 0, // These values aren't available in the new stats
              //   second: 0,
              //   third: 0,
              // }}
              mainLabel="Awaiting"
              subLabel="Last 30 Days"
              buttonText={`Go to ${NAVIGATION_ITEMS.INVITED.label}`}
              buttonAction={navigateTo('invited')}
            />
          </Grid>
          <Grid item xs={12} md={12} lg={6}>
            <SectionCard
              title={NAVIGATION_ITEMS.SCHEDULED.label}
              icon={NAVIGATION_ITEMS.SCHEDULED.icon}
              mainValue={stats.numberOfScheduledInvitations || 0}
              mainLabel="Booked For"
              subLabel="Next 30 Days"
              buttonText={`Go to ${NAVIGATION_ITEMS.SCHEDULED.label}`}
              buttonAction={navigateTo('scheduled')}
            />
          </Grid>
          <Grid item xs={12} md={12} lg={6}>
            <SectionCard
              title={NAVIGATION_ITEMS.COMPLETED.label}
              icon={NAVIGATION_ITEMS.COMPLETED.icon}
              mainValue={stats.numberOfCompletedInvitations || 0}
              mainLabel="Completed"
              buttonText={`Go to ${NAVIGATION_ITEMS.COMPLETED.label}`}
              buttonAction={navigateTo('completed')}
            />
          </Grid>
          <Grid item xs={12} md={12} lg={6}>
            <SectionCard
              title={NAVIGATION_ITEMS.DECLINED.label}
              icon={NAVIGATION_ITEMS.DECLINED.icon}
              mainValue={stats.numberOfDeclinedInvitations || 0}
              mainLabel="Declined"
              buttonText={`Go to ${NAVIGATION_ITEMS.DECLINED.label}`}
              buttonAction={navigateTo('declined')}
            />
          </Grid>
          <Grid item xs={12} md={12} lg={6}>
            <SectionCard
              title={NAVIGATION_ITEMS.UNCONTACTABLE.label}
              icon={NAVIGATION_ITEMS.UNCONTACTABLE.icon}
              mainValue={stats.numberOfUncontactableInvitations || 0}
              mainLabel="Uncontactable"
              buttonText={`Go to ${NAVIGATION_ITEMS.UNCONTACTABLE.label}`}
              buttonAction={navigateTo('uncontactable')}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export function AnnualReviewsDashboardPage() {
  return (
    <>
      <MeetingTabs />
      <AnnualReviewsDashboard />
    </>
  );
}
